var Component = require("!./../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!./../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-45b78e9f!./../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./featured-products.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/partials/featured-products.vue
// module id = 25
// module chunks = 0